module.exports = __webpack_public_path__ + "img/图片21.2300cfd2.png";